<script lang="ts">
    import {State} from './types';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    let collapsed = true;
    let state = collapsed ? State.Closed : State.Open;

    function setStartPosition() {
        if (!collapsed) {
            state = State.Opening;
        } else {
            state = State.Closing;
        }
    }

    function setEndPosition() {
        if (!collapsed) {
            state = State.Open;
        } else {
            state = State.Closed;
        }
    }

    function collapse() {
        collapsed = true;
    }

    function expended() {
        collapsed = false;
    }

    function changeBasedOnState() {
        if (state === State.Closing || state === State.Closed) {
            collapsed = false;
        }

        if (state === State.Opening || state === State.Open) {
            collapsed = true;
        }
    }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="side-bar"
     class:collapsed={collapsed}
     class:not-collapsed={!collapsed}
     on:transitionstart={setStartPosition}
     on:transitionend={setEndPosition}
     on:mouseenter={expended}
     on:mouseleave={collapse}>

    <ul class="features-list">
        <slot {collapsed} {state}></slot>
    </ul>

    <!-- this button is not accessible by keyboard, because it is not needed by screen readers users -->
    <button class="btn-block btn-clear side-bar-collapser-button" aria-hidden="true" tabindex="-1" on:click={changeBasedOnState}>
        <UIcon icon="angle-small-{collapsed ? 'left' : 'right'}"/>
    </button>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.media-queries.less";
    @import (reference) "src/shared/ui-widgets/collapsible-button-menu/collapsible-menu.constants.less";

    .not-collapsed {
        width: @full-width;
        @media screen and (max-width: @screen-xs-min) {
            & {
                width: @full-width-xs;
            }
        }
    }

    .collapsed {
        width: @collapsed-width;
    }

    .side-bar {
        overflow: hidden;
        display: flex;
        height: 100%;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: space-around;
        background-color: @background-color;
        border: 1px solid @border-color;
        transition: width 0.3s;

        .features-list {
            display: flex;
            flex-direction: column;
            list-style: none;
            width: 100%;
        }

        .side-bar-collapser-button {
            position: relative;
            display: flex;
            padding: @spacing-s 0;
            cursor: pointer;
            justify-content: center;
            color: @icon-color;
        }

        .side-bar-collapser-button:hover {
            background: @logo-background-color;
        }

        .btn-clear {
            margin-top: 1em;
            background: none;
            color: inherit;
            border: none;
            cursor: pointer;
            outline: inherit;
        }
    }

    :global(.collapsible-menu-item) {
        width: 100%;
        position: relative;
        padding: 0.2em 0.4em;
        cursor: pointer;
        transition: 0.3s ease;
    }
</style>